import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { Switch } from "../ui/switch";
import { Power, Clock, Timer, Save, Loader2 } from "lucide-react";

export default function LoopControl({ loop, setLoop, allClients, saving, onSave, metrics }) {
  if (!loop) return null;
  const behaviors = (metrics && metrics.behaviors_today) || {};
  const setHuman = (patch) => setLoop((s) => ({ ...s, ...patch }));
  return (
    <div className="glass-card overflow-hidden" data-testid="admin-loop-card">
      <div className="section-accent p-5 sm:p-6">
        <h2 className="font-heading text-lg font-semibold text-slate-100 flex items-center gap-2.5">
          <Power className={`w-5 h-5 ${loop.loop_master ? "text-emerald-400" : "text-red-400"}`} />
          Controle Mestre do Loop de Maturação
        </h2>
        <p className="text-xs text-slate-500 mt-1">Liga/desliga global, agenda de disparos para todos os chips ou clientes selecionados, e cadência anti-ban.</p>
      </div>
      <div className="p-5 sm:p-6 grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="space-y-4">
          <div className="flex items-center justify-between gap-3 bg-white/[0.03] border border-white/[0.06] rounded-xl p-4">
            <div>
              <p className="text-sm font-semibold text-slate-200">Loop global</p>
              <p className="text-[11px] text-slate-500">{loop.loop_master ? "Motor ativo para todos os chips" : "Motor pausado — nenhum chip dispara"}</p>
            </div>
            <Switch checked={loop.loop_master} onCheckedChange={(v) => setLoop((s) => ({ ...s, loop_master: v }))} data-testid="admin-loop-master-switch" />
          </div>
          <div className="bg-white/[0.03] border border-white/[0.06] rounded-xl p-4 space-y-3">
            <p className="text-xs font-semibold uppercase tracking-wider text-slate-400 flex items-center gap-1.5">
              <Timer className="w-4 h-4 text-amber-400" /> Cadência anti-ban (bounds globais)
            </p>
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="text-[10px] text-slate-500 uppercase">Delay mín (s)</label>
                <Input type="number" min={5} value={loop.cadence_delay_min} onChange={(e) => setLoop((s) => ({ ...s, cadence_delay_min: e.target.value }))}
                  data-testid="admin-loop-delay-min" className="bg-slate-800/60 border-slate-700 text-slate-100 font-mono h-9 mt-1" />
              </div>
              <div>
                <label className="text-[10px] text-slate-500 uppercase">Delay máx (s)</label>
                <Input type="number" min={5} value={loop.cadence_delay_max} onChange={(e) => setLoop((s) => ({ ...s, cadence_delay_max: e.target.value }))}
                  data-testid="admin-loop-delay-max" className="bg-slate-800/60 border-slate-700 text-slate-100 font-mono h-9 mt-1" />
              </div>
              <div>
                <label className="text-[10px] text-slate-500 uppercase">Digitando mín (s)</label>
                <Input type="number" min={0} value={loop.typing_min} onChange={(e) => setLoop((s) => ({ ...s, typing_min: e.target.value }))}
                  data-testid="admin-loop-typing-min" className="bg-slate-800/60 border-slate-700 text-slate-100 font-mono h-9 mt-1" />
              </div>
              <div>
                <label className="text-[10px] text-slate-500 uppercase">Digitando máx (s)</label>
                <Input type="number" min={0} value={loop.typing_max} onChange={(e) => setLoop((s) => ({ ...s, typing_max: e.target.value }))}
                  data-testid="admin-loop-typing-max" className="bg-slate-800/60 border-slate-700 text-slate-100 font-mono h-9 mt-1" />
              </div>
            </div>
          </div>
        </div>
        <div className="space-y-4">
          <div className="bg-white/[0.03] border border-white/[0.06] rounded-xl p-4 space-y-3">
            <div className="flex items-center justify-between">
              <p className="text-xs font-semibold uppercase tracking-wider text-slate-400 flex items-center gap-1.5">
                <Clock className="w-4 h-4 text-blue-400" /> Agenda global de disparos
              </p>
              <Switch checked={loop.schedule_enabled} onCheckedChange={(v) => setLoop((s) => ({ ...s, schedule_enabled: v }))} data-testid="admin-loop-schedule-switch" />
            </div>
            {loop.schedule_enabled && (
              <>
                <div className="grid grid-cols-2 gap-3">
                  <div>
                    <label className="text-[10px] text-slate-500 uppercase">Início</label>
                    <Input type="time" value={loop.schedule_start} onChange={(e) => setLoop((s) => ({ ...s, schedule_start: e.target.value }))}
                      data-testid="admin-loop-schedule-start" className="bg-slate-800/60 border-slate-700 text-slate-100 font-mono h-9 mt-1" />
                  </div>
                  <div>
                    <label className="text-[10px] text-slate-500 uppercase">Fim</label>
                    <Input type="time" value={loop.schedule_end} onChange={(e) => setLoop((s) => ({ ...s, schedule_end: e.target.value }))}
                      data-testid="admin-loop-schedule-end" className="bg-slate-800/60 border-slate-700 text-slate-100 font-mono h-9 mt-1" />
                  </div>
                </div>
                <Select value={loop.schedule_target} onValueChange={(v) => setLoop((s) => ({ ...s, schedule_target: v }))}>
                  <SelectTrigger data-testid="admin-loop-target-select" className="bg-slate-800/60 border-slate-700 text-slate-100 h-9">
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent className="bg-slate-900 border-slate-700 text-slate-100">
                    <SelectItem value="all">Todos os chips da plataforma</SelectItem>
                    <SelectItem value="selected">Somente clientes selecionados</SelectItem>
                  </SelectContent>
                </Select>
              </>
            )}
            {!loop.schedule_enabled && (
              <p className="text-[11px] text-slate-500">Sem agenda global: vale a agenda individual de cada cliente (padrão 08:00–22:30).</p>
            )}
          </div>
        </div>
        <div className="space-y-4">
          {loop.schedule_enabled && loop.schedule_target === "selected" ? (
            <div className="bg-white/[0.03] border border-white/[0.06] rounded-xl p-4">
              <p className="text-xs font-semibold uppercase tracking-wider text-slate-400 mb-3">Clientes incluídos no disparo</p>
              <div className="max-h-48 overflow-y-auto space-y-1.5 pr-1" data-testid="admin-loop-clients">
                {allClients.map((c) => (
                  <label key={c.id} className="flex items-center gap-2.5 text-sm text-slate-300 hover:text-slate-100 cursor-pointer py-1">
                    <input type="checkbox"
                      checked={(loop.schedule_user_ids || []).includes(c.id)}
                      onChange={(e) => setLoop((s) => ({
                        ...s,
                        schedule_user_ids: e.target.checked
                          ? [...(s.schedule_user_ids || []), c.id]
                          : (s.schedule_user_ids || []).filter((x) => x !== c.id),
                      }))}
                      data-testid={`admin-loop-client-${c.id}`}
                      className="w-4 h-4 rounded border-slate-600 bg-slate-800 accent-emerald-500" />
                    <span className="truncate">{c.name} <span className="text-slate-500 text-xs">({c.email})</span></span>
                  </label>
                ))}
                {allClients.length === 0 && <p className="text-xs text-slate-500">Nenhum cliente cadastrado.</p>}
              </div>
            </div>
          ) : (
            <div className="bg-white/[0.03] border border-white/[0.06] rounded-xl p-4 text-[11px] text-slate-500 leading-relaxed">
              Com "Todos os chips" selecionado, a agenda global se aplica a cada chip da base. Escolha "clientes selecionados" para segmentar por cliente via caixas de seleção.
            </div>
          )}
          <Button onClick={onSave} disabled={saving} data-testid="admin-loop-save"
            className="w-full bg-emerald-500 hover:bg-emerald-600 text-emerald-950 font-semibold">
            {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : (<><Save className="w-4 h-4 mr-2" /> Aplicar configuração global</>)}
          </Button>
        </div>
      </div>
      <div className="p-5 sm:p-6 pt-0">
        <div className="bg-white/[0.03] border border-white/[0.06] rounded-xl p-4 space-y-4">
          <div>
            <p className="text-xs font-semibold uppercase tracking-wider text-slate-400">Humanização dos chips (plano master — vale para todos)</p>
            <p className="text-[11px] text-slate-500 mt-1">Leitura, resposta citada, reações, enquetes e perfil. Desligar volta ao comportamento anterior na hora, sem rebuild.</p>
          </div>
          {(behaviors.resposta_citada || behaviors.reacao || behaviors.enquete || behaviors.correcao) ? (
            <p className="text-[11px] text-slate-400 font-mono" data-testid="admin-human-behaviors-today">
              Hoje: {behaviors.resposta_citada || 0} respostas citadas · {behaviors.reacao || 0} reações · {behaviors.enquete || 0} enquetes · {behaviors.enquete_voto || 0} votos · {behaviors.correcao || 0} correções
            </p>
          ) : null}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-3">
            <div className="flex items-center justify-between gap-2 bg-slate-800/40 rounded-xl p-3">
              <div>
                <p className="text-xs font-semibold text-slate-200">Ler antes de responder</p>
                <p className="text-[10px] text-slate-500">Marca como lida</p>
              </div>
              <Switch checked={!!loop.human_read_enabled} onCheckedChange={(v) => setHuman({ human_read_enabled: v })} data-testid="admin-human-read-switch" />
            </div>
            <div className="bg-slate-800/40 rounded-xl p-3 space-y-2">
              <div className="flex items-center justify-between gap-2">
                <div>
                  <p className="text-xs font-semibold text-slate-200">Responder citando</p>
                  <p className="text-[10px] text-slate-500">Prob. 0–1</p>
                </div>
                <Switch checked={!!loop.human_reply_enabled} onCheckedChange={(v) => setHuman({ human_reply_enabled: v })} data-testid="admin-human-reply-switch" />
              </div>
              <Input type="number" min={0} max={1} step={0.05} value={loop.human_reply_prob ?? 0.7}
                onChange={(e) => setHuman({ human_reply_prob: e.target.value })}
                data-testid="admin-human-reply-prob" className="bg-slate-800/60 border-slate-700 text-slate-100 font-mono h-9" />
            </div>
            <div className="bg-slate-800/40 rounded-xl p-3 space-y-2">
              <div className="flex items-center justify-between gap-2">
                <div>
                  <p className="text-xs font-semibold text-slate-200">Reagir com emoji</p>
                  <p className="text-[10px] text-slate-500">Prob. 0–1</p>
                </div>
                <Switch checked={!!loop.human_react_enabled} onCheckedChange={(v) => setHuman({ human_react_enabled: v })} data-testid="admin-human-react-switch" />
              </div>
              <Input type="number" min={0} max={1} step={0.05} value={loop.human_react_prob ?? 0.2}
                onChange={(e) => setHuman({ human_react_prob: e.target.value })}
                data-testid="admin-human-react-prob" className="bg-slate-800/60 border-slate-700 text-slate-100 font-mono h-9" />
            </div>
            <div className="bg-slate-800/40 rounded-xl p-3 space-y-2">
              <div className="flex items-center justify-between gap-2">
                <div>
                  <p className="text-xs font-semibold text-slate-200">Enquetes em grupo</p>
                  <p className="text-[10px] text-slate-500">Máx/dia por grupo</p>
                </div>
                <Switch checked={!!loop.human_poll_enabled} onCheckedChange={(v) => setHuman({ human_poll_enabled: v })} data-testid="admin-human-poll-switch" />
              </div>
              <Input type="number" min={1} max={5} value={loop.human_poll_per_group_day ?? 1}
                onChange={(e) => setHuman({ human_poll_per_group_day: e.target.value })}
                data-testid="admin-human-poll-max" className="bg-slate-800/60 border-slate-700 text-slate-100 font-mono h-9" />
            </div>
            <div className="bg-slate-800/40 rounded-xl p-3 space-y-2">
              <div className="flex items-center justify-between gap-2">
                <div>
                  <p className="text-xs font-semibold text-slate-200">Figurinhas</p>
                  <p className="text-[10px] text-slate-500">Prob. 0–1</p>
                </div>
                <Switch checked={!!loop.human_sticker_enabled} onCheckedChange={(v) => setHuman({ human_sticker_enabled: v })} data-testid="admin-human-sticker-switch" />
              </div>
              <Input type="number" min={0} max={1} step={0.01} value={loop.human_sticker_prob ?? 0.05}
                onChange={(e) => setHuman({ human_sticker_prob: e.target.value })}
                data-testid="admin-human-sticker-prob" className="bg-slate-800/60 border-slate-700 text-slate-100 font-mono h-9" />
            </div>
            <div className="bg-slate-800/40 rounded-xl p-3 space-y-2">
              <div className="flex items-center justify-between gap-2">
                <div>
                  <p className="text-xs font-semibold text-slate-200">Correção *palavra</p>
                  <p className="text-[10px] text-slate-500">Prob. 0–1</p>
                </div>
                <Switch checked={!!loop.human_edit_enabled} onCheckedChange={(v) => setHuman({ human_edit_enabled: v })} data-testid="admin-human-edit-switch" />
              </div>
              <Input type="number" min={0} max={1} step={0.01} value={loop.human_edit_prob ?? 0.02}
                onChange={(e) => setHuman({ human_edit_prob: e.target.value })}
                data-testid="admin-human-edit-prob" className="bg-slate-800/60 border-slate-700 text-slate-100 font-mono h-9" />
            </div>
            <div className="flex items-center justify-between gap-2 bg-slate-800/40 rounded-xl p-3">
              <div>
                <p className="text-xs font-semibold text-slate-200">Perfil ao conectar</p>
                <p className="text-[10px] text-slate-500">Nome + privacidade</p>
              </div>
              <Switch checked={!!loop.human_profile_enabled} onCheckedChange={(v) => setHuman({ human_profile_enabled: v })} data-testid="admin-human-profile-switch" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
